/*
 * Autoplay fallback for videos rendered by snippets/light-video.liquid.
 *
 * Once each video has loaded, call play(). If the browser refuses to autoplay
 * (e.g. an iPhone in Low Power Mode rejects with NotAllowedError), replace the
 * <video> with an <img>. Safari plays an MP4 inside <img> (smooth, silent,
 * allowed in Low Power Mode), so the MP4 is tried first; browsers that cannot
 * decode it fall back to the animated WebP. The WebP URL only lives in a data
 * attribute, so visitors whose autoplay works never download it.
 */
(function () {
  'use strict';

  // Rejections that mean the clip will not play on its own. AbortError (play()
  // interrupted by pause() or a new load) is deliberately ignored.
  var BLOCKED = { NotAllowedError: true, NotSupportedError: true };

  function swapForImage(video) {
    var webp = video.getAttribute('data-fallback-src');
    var source = video.querySelector('source');
    var mp4 = (source && source.getAttribute('src')) || video.getAttribute('src');
    var src = mp4 || webp;
    var parent = video.parentNode;
    if (!src || !parent) return;

    var img = document.createElement('img');
    img.className = video.className;
    if (video.getAttribute('style')) img.setAttribute('style', video.getAttribute('style'));
    img.style.borderRadius = window.getComputedStyle(video).borderRadius;
    img.width = video.width || video.videoWidth;
    img.height = video.height || video.videoHeight;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    if (mp4 && webp) {
      img.addEventListener('error', function () { img.src = webp; }, { once: true });
    }
    img.src = src;

    parent.replaceChild(img, video);

    // Stop the detached video from downloading any further.
    Array.prototype.forEach.call(video.querySelectorAll('source'), function (source) {
      source.removeAttribute('src');
    });
    video.removeAttribute('src');
    video.load();
  }

  function attempt(video) {
    if (video.lightVideoTried) return;
    video.lightVideoTried = true;

    var result;
    try {
      result = video.play();
    } catch (error) {
      if (error && BLOCKED[error.name]) swapForImage(video);
      return;
    }

    if (result && typeof result.catch === 'function') {
      result.catch(function (error) {
        if (error && BLOCKED[error.name]) swapForImage(video);
      });
    }
  }

  function init(video) {
    if (video.readyState >= 1) {
      attempt(video);
      return;
    }
    video.addEventListener('loadedmetadata', function () { attempt(video); }, { once: true });
    // iOS may not fetch anything without a user gesture, so don't wait for metadata forever.
    window.addEventListener('load', function () { attempt(video); }, { once: true });
  }

  function initAll(root) {
    Array.prototype.forEach.call(root.querySelectorAll('video[data-light-video]'), init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
